<template>
  <div>

    <div class="text-left">

      <template v-if="this.$route.name == 'updateOrder'">
        <router-link :to="{ name: 'Factor', params: { orderId: $route.params.id } }">
          <button type="button" class="btn rounded-pill mx-2 btn-primary">مشاهده فاکتور</button>
        </router-link>
      </template>

      <router-link :to="ordersButton">
        <button type="button" class="btn rounded-pill mx-2 btn-primary">سفارشات</button>
      </router-link>

    </div>

    <b-col lg="12" class="mt-3 ml-auto mr-auto">
      <div class="row">
        <div class="col-lg-6 ">
          <b-form-input placeholder="جست و جو در محصولات" v-model="searchOnProduct" @keyup.enter="searchProducts"/>
          <b-col cols="12" class="text-center w-100 px-2 py-3 overflow-manager rounded">
            <div v-for="(product,index) in products" :key="index">
              <div v-for="(sub_product,index) in subProducts(product)" :key="index*2">

                <span @click="addProduct(sub_product,product)" class="selected_item cursor_pointer p-2 ml-2 rounded">
                    {{ productName(product, sub_product.id) }} {{ productType(product) }}
                </span>
                <hr class="text-secondary w-100">

              </div>

            </div>
            <p v-if="products.length==0" class="text-center">هیچ محصولی یافت نشد!</p>
          </b-col>
        </div>
        <div class="col-lg-6 ">
          <b-form-input
              @keypress.enter.prevent="searchUser"
              v-model="searchUserWords"
              placeholder="نام، نام خانوادگی یا شماره تلفن کاربر"
          ></b-form-input>

          <div class="text-center overflow-manager">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">نام نام خانوادگی</th>
                <th scope="col">شماره تلفن همراه</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="person in persons" @click="selectedPersonManager(person)"
                  :class="selectedPerson == person.id ?'bg-primary text-white' : ''">
                <td>{{ person.name }} {{ person.last_name }}</td>
                <td>{{ person.cellphone }}</td>
              </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>
    </b-col>

    <form @submit.prevent="onSubmit">
      <b-col lg="12">


        <b-container>
          <b-row>

            <table class="table my-3">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">محصول</th>
                <th scope="col">تعداد</th>
                <th scope="col">قیمت</th>
                <th scope="col">تخفیف</th>
                <th scope="col">قابل پرداخت</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in form.product" :key="index">
                <th>{{ index + 1 }}</th>
                <td>
                  <span>{{ item.name }}</span>
                </td>
                <th>
                  <div class="d-inline-block">
                    <a class="control-btn">
                      <b-icon class="text-white p-1 bg-secondary rounded-circle "
                              @click="changeProductMode(index,item,'up')"
                              icon="plus"/>
                    </a>

                    <input type="number" min="1"
                           @keypress="changeInputQuantity(index,item)"
                           :id="`product-${item.hash}`"
                           :value="item.quantity"
                           :style="{width:`${setInputSize(item.quantity)}px`}"
                           class="text-center mx-1 quantity-input-manager d-inline border-1 form-control"/>

                    <a class="control-btn ">
                      <b-icon class="text-white p-1 bg-secondary rounded-circle "
                              @click="changeProductMode(index,item,'down')"
                              icon="dash"/>
                    </a>

                    <a class="control-btn ">
                      <b-icon class="text-white p-1 mr-3 bg-secondary rounded-circle "
                              @click="changeProductMode(index,item,'trash')" icon="trash"/>
                    </a>
                  </div>
                </th>
                <td>
                  <create-order-offer-price-manager mode="price" :product="item.product"
                                                    @changeValue="refreshFunction"
                                                    :sub-product="item.sub_product"/>

                  <p>{{ formatNumber(item.product['custom_price']) }} تومان</p>
                </td>
                <td>
                  <create-order-offer-price-manager mode="offer" :product="item.product"
                                                    @changeValue="refreshFunction"
                                                    :sub-product="item.sub_product"/>
                  <p> {{ formatNumber(item.product['custom_offer']) }} تومان</p>

                </td>
                <td>{{
                    formatNumber((item.product['custom_price'] - item.product['custom_offer']) * item.quantity)
                  }}
                </td>
              </tr>
              </tbody>
            </table>

            <table class="table my-3">
              <thead>
              <tr>
                <th scope="col">جمع اقلام</th>  <!--جمع تعداد-->
                <th scope="col">قیمت کل</th>
                <th scope="col">جمع تخفیف</th>
                <th scope="col">قابل پرداخت</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>{{ formatNumber(summarizeFactor()['totalQuantity']) }}</th>
                <th>{{ formatNumber(summarizeFactor()['totalPrice']) }}</th>
                <th>{{ formatNumber(summarizeFactor()['totalOffer']) }}</th>
                <th>{{ formatNumber(summarizeFactor()['payingAmount']) }}</th>
              </tr>
              </tbody>
            </table>


          </b-row>
        </b-container>

        <b-form-row v-if="selectedPerson == null">
          <b-col class="my-2">
            <b-form-input required v-model="form.name" placeholder="نام"></b-form-input>
          </b-col>

          <b-col class="my-2">
            <b-form-input required v-model="form.last_name" placeholder="نام خانوادگی"></b-form-input>
          </b-col>

          <b-col class="my-2">
            <b-form-input required v-model="form.cellphone" placeholder="شماره موبایل"></b-form-input>
          </b-col>
        </b-form-row>

        <hr>

        <div class="my-5 text-center">
          <p>نوع آدرس را مشخص کنید.</p>
          <div class="form-check form-check-inline">
            <input class="form-check-input" required v-model="deliveryMode"
                   type="radio" name="deliveryMode"
                   id="default_address"
                   value="default_address">
            <label class="form-check-label mx-2" for="default_address">حضوری</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" required v-model="deliveryMode" type="radio"
                   name="deliveryMode" id="new_address"
                   value="new_address">
            <label class="form-check-label mx-2" for="new_address">ارسال</label>
          </div>
        </div>
        <hr>


        <b-form-row v-if="deliveryMode == 'new_address'">

          <b-col class="my-2" lg="12">
            <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                          list="provinces-list" placeholder="استان"></b-form-input>
            <datalist id="provinces-list">
              <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                  province.name
                }}
              </option>
            </datalist>
          </b-col>

          <b-col class="my-2" lg="12">
            <b-form-input v-if="isProvinceFill" v-model="form.city" list="cities-list" debounce="400"
                          @update="citySearch" autocomplete="off" placeholder="شهر"></b-form-input>
            <datalist id="cities-list">
              <option v-for="city in cities">{{ city.name }}</option>
            </datalist>
          </b-col>

          <b-col class="my-2" lg="12">
            <b-form-input v-model="form.address" placeholder="آدرس"></b-form-input>
          </b-col>

          <b-col class="my-2" lg="12">
            <b-form-input required v-model="form.postal_code" placeholder="کدپستی"></b-form-input>
          </b-col>

          <b-col class="my-2" lg="12">
            <b-form-textarea v-model="form.address_description" placeholder="توضیحات آدرس"></b-form-textarea>
          </b-col>

        </b-form-row>

        <div class="form-row" v-if="deliveryMode == 'default_address'">

          <select name="default_address" v-model="deliveryDefaultValue" required class="custom-select">
            <option value="">یکی از آدرس های زیر را انتخاب کنید.</option>
            <option v-for="address in addresses" :key="address.id" :value="address">{{ address.name }}</option>
          </select>
        </div>

        <b-form-row>

          <b-col class="my-2" lg="12">
            <b-form-textarea v-model="form.order_description" placeholder="توضیحات سفارش"></b-form-textarea>
          </b-col>

        </b-form-row>

        <b-form-group class="my-4">
          <p>نوع فاکتور</p>

          <b-form-radio required class="d-inline mx-2" v-model="form.in_out_flag"
                        value="0"
                        name="in_out_flag">
            فروش
          </b-form-radio>

          <b-form-radio required class="d-inline mx-2" v-model="form.in_out_flag"
                        value="1"
                        name="in_out_flag">
            ورود کالا
          </b-form-radio>

        </b-form-group>

        <b-form-group class="my-4">
          <p>نوع پرداخت</p>

          <template v-if="form.in_out_flag == 0">
            <b-form-radio required class="d-inline mx-2" v-model="form.gateway"
                          value="loan"
                          name="payment-method">
              اقساط
            </b-form-radio>

            <b-form-radio required class="d-inline mx-2" v-model="form.gateway"
                          value="without-gate"
                          name="payment-method">
              بدون درگاه
            </b-form-radio>
          </template>

          <template v-if="form.in_out_flag == 1">
            <b-form-radio required class="d-inline mx-2" v-model="form.gateway"
                          value="cash"
                          name="payment-method">
              نقد
            </b-form-radio>

            <b-form-radio required class="d-inline mx-2" v-model="form.gateway"
                          value="card"
                          name="payment-method">
              کارت
            </b-form-radio>
          </template>

        </b-form-group>

        <b-button block pill type="submit" class=" w-25 d-inline" variant="primary">
          ثبت
        </b-button>
        <template v-if="this.$route.name == 'updateOrder'">
          <router-link :to="{ name: 'Factor', params: { orderId: $route.params.id } }">
            <button type="button" class="btn rounded-pill mx-2 btn-primary">مشاهده فاکتور</button>
          </router-link>
        </template>

        <router-link :to="ordersButton">
          <button type="button" class="btn rounded-pill mx-2 btn-primary">سفارشات</button>
        </router-link>


      </b-col>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  subProducts, productName
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {shoppingCartFunctions} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import debounce from "lodash/debounce";
import {generateHash} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart'
import CreateOrderOfferPriceManager from './CreateOrderComponents/CreateOrderOfferPriceManager.vue'


export default {
  name: "CreateOrder",
  components: {CreateOrderOfferPriceManager},
  data() {
    return {
      form: {
        name: '',
        last_name: '',
        province: '',
        city: '',
        address: '',
        cellphone: '',
        postal_code: '',
        address_description: '',
        order_description: '',
        gateway: '',
        product: [],
        in_out_flag:0
      },
      selectedPerson: null,
      searchUserWords: '',
      searchOnProduct: '',
      quantityInputWidth: 40,
      deliveryMode: null,
      deliveryDefaultValue: '',
    };
  },
  computed: {
    ...mapGetters({
      provinces: "Province/getProvinces",
      cities: "City/getCities",
      products: "Product/getProducts",
      persons: "User/getPersons",
      addresses: 'Address/getAddresses',
      isStore:"User/isUserStore",
    }),
    isProvinceFill() {
      return findObjects(this.$store.getters['Province/getProvinces'], this.form.province) != null
    },
    ordersButton(){

      if(this.isStore){
        return {name:"UserOrders"}
      }
      return {name:'Orders'}
    }

  },
  methods: {
    productName,
    ...shoppingCartFunctions,
    ...mapActions({
      'provinceSearch': "Province/search",
      getPersons: "User/getPersons",
    }),
    toast,
    generateHash,
    formatNumber,
    findHashProductOnLocalStorage,
    subProducts,
    citySearch(words) {
      let province = findObjects(this.$store.getters['Province/getProvinces'], this.form.province).id;
      this.$store.dispatch('City/search', {words, province});
    },
    onSubmit() {
      try {
        let form = this.form

        /* remove empty subProduct */
        Object.entries(form.product).forEach(item => {
          if (item[1].sub_product == null) {
            delete item[1]['sub_product']
          }

          // set price and offer
          item[1]['price'] = item[1]['product']['custom_price']
          item[1]['offer'] = item[1]['product']['custom_offer']

        })

        if (this.deliveryMode === 'default_address') {
          form['default_address'] = this.deliveryDefaultValue.id
        } else { // remove default_address if we are in create_address mode


          delete form['default_address']
          let province = 0
          let city = 0

          if (this.findAttributeOnSiteInfo('default_city')) {
            const site_info_city = this.findAttributeOnSiteInfo('default_city')[0];
            province = site_info_city.province.id;
            city = site_info_city.id;
          } else {
            province = findObjects(this.$store.getters['Province/getProvinces'], form.province).id;
            city = findObjects(this.$store.getters['City/getCities'], form.city).id;
          }

          form = {...form, province_id: province, city_id: city}


        }


        if (this.selectedPerson != null) {
          form['user_id'] = this.selectedPerson
        }

        let req = this.$store.dispatch('Transaction/transactionWithoutAuthentication', {form: form, mode: 'dashboard'})
        req.then(res => {
          let orderId = res.data.data.id
          this.$router.push({name: 'updateOrder', params: {id: orderId}})
        })

      } catch (e) {
        console.log(e)
        toast('شهر یا استان انتخاب شده یافت نشد', 'شهر یا استان انتخاب شده یافت نشد', 'danger')
      }
    },
    searchProducts() {
      if (this.searchOnProduct.trim() !== '') {
        this.$store.commit('Product/setFilters', {key: 'search', value: this.searchOnProduct})
        this.$store.commit('Product/setFilters', {key: 'is_digital', value: ''})
        this.$store.dispatch('Product/filteredProducts');
      }

    },
    refreshFunction() {
      this.$forceUpdate()
    },
    productType(product) {
      return product.is_digital == 0 ? '(فیزیکی)' : '(دیجیتال)'
    },
    addProduct(subProduct, product) {

      let subProductId = product.variation == 0 ? null : subProduct.id

      const newItem = {
        hash: this.generateHash(),
        id: product.id,
        name: this.productName(product, subProductId),
        product: product,
        sub_product: subProductId,
        quantity: 1,
      }

      let checker = true;
      this.form.product.forEach(item => {
        if (item.id == product.id && item.sub_product == product.sub_product_id) {
          checker = false
        }
      })

      if (checker) {
        this.form.product.push(newItem)
      } else {
        this.toast('محصول قبلا انتخاب شده است', 'محصول قبلا انتخاب شده است', 'danger')
      }
    },
    changeProductMode(productIndex, product, mode = 'up') {
      if (mode === 'trash') {
        this.form.product.splice(productIndex, 1)
      }
      if (mode === 'up') {
        if (this.quantityChecker(product.quantity + 1, product.product, product.sub_product)) {
          this.form.product[productIndex]['quantity']++
        }
      }
      if (mode === 'down') {
        if (this.form.product[productIndex]['quantity'] > 1) {
          this.form.product[productIndex]['quantity']--
        }
      }
    },
    changeInputQuantity: debounce(function (productIndex, product) {
      const quantity = this.form.product[productIndex].quantity;
      const productQuantityInput = document.getElementById(`product-${product.hash}`)
      const checkQuantity = this.quantityChecker(productQuantityInput.value, product.product, product.sub_product);

      if (checkQuantity) {
        this.form.product[productIndex].quantity = productQuantityInput.value
      } else {
        this.toast('اتمام موجودی', 'اتمام موجودی', 'danger')
      }
      productQuantityInput.value = quantity

    }, 1),
    setInputSize(quantity) {
      quantity = this.quantityInputWidth + parseInt(quantity) / 2;
      if (quantity > 150) {
        quantity = 150
      }
      return quantity
    },
    searchUser() {
      let page = 1
      this.$store.commit('User/setFilters', {key: 'search', value: this.searchUserWords})
      this.$store.dispatch("User/getPersons", page);
    },
    selectedPersonManager(person) {
      if (this.selectedPerson == null || this.selectedPerson != person.id) {
        this.selectedPerson = person.id
      } else {
        this.selectedPerson = null
      }
    },
    summarizeFactor() {
      let result = {
        totalQuantity: 0,
        totalPrice: 0,
        totalOffer: 0,
        payingAmount: 0
      }

      this.form.product.forEach(item => {

        let totalOffer = item.product['custom_offer'] * item.quantity
        let totalPrice = item.product['custom_price'] * item.quantity


        result['totalQuantity'] += parseInt(item.quantity)
        result['totalPrice'] += totalPrice
        result['totalOffer'] += totalOffer
        result['payingAmount'] += totalPrice - totalOffer

      })


      return result

    },
    async setFormInUpdateMode() {
      let orderId = this.$route.params.id

      let factor = await this.$store.dispatch('Transaction/autoPrintShowTransactionDetail', orderId)
      let factorData = factor.data.data

      this.form['slug'] = factorData.slug

      // set products
      factorData.items.forEach(item => {

        item.product['custom_price'] = item.price
        item.product['price'] = item.price
        item.product['bulks'] = []
        item.product['custom_offer'] = item.offer_on_product
        item.product['offer'] = item.offer_on_product

        this.form.product.push({
          id: item.product.id,
          name: this.productName(item.product, item.sub_product),
          hash: this.generateHash(),
          product: item.product,
          sub_product: item.sub_product,
          quantity: item.quantity
        })
      })

      // set description
      this.form.order_description = factorData.description

      // set user
      this.selectedPerson = factorData.user.id

      // set address
      let address = factorData.address
      if (address.default_address == 1) {
        this.deliveryMode = 'default_address'
        this.deliveryDefaultValue = address
      } else {
        this.deliveryMode = 'new_address'
        this.form.province = address.province.name
        this.form.city = address.city.name
        this.form.address_description = address.description
        this.form.address = address.address
        this.form.postal_code = address.postal_code

        await this.provinceSearch(this.form.province)

        await this.citySearch(this.form.city)


      }

    }
  },
  async mounted() {
    await this.$store.dispatch("Address/setDefaultAddresses")
    window.addEventListener('click', this.refreshFunction);
    window.addEventListener('DOMContentLoaded', this.refreshFunction);

    if (this.$route.name == 'updateOrder') {

      await this.setFormInUpdateMode();

    }

  },
}
</script>

<style scoped>
.cursor_pointer {
  cursor: pointer;
}

.selected_item {
  background-color: var(--secondary);
  color: white;
}

.control-btn {
  font-size: 26px !important
}

.overflow-manager {
  height: 250px;
  overflow-y: auto;
}

.product-image {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>